"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _activityList = _interopRequireDefault(require("./activityList.vue"));
var _activityAdd = _interopRequireDefault(require("./activityAdd.vue"));
var _recordList = _interopRequireDefault(require("./recordList.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tieTuNumber',
  components: {
    activityList: _activityList.default,
    activityAdd: _activityAdd.default,
    recordList: _recordList.default
  },
  data: function data() {
    return {
      refresh: false,
      actId: null,
      publishKey: 0,
      rewardKey: 0,
      activeTab: 'activityList'
    };
  },
  methods: {
    saved: function saved() {
      this.activeTab = 'activityList';
      this.refresh = true;
    },
    addAct: function addAct() {
      this.activeTab = 'activityAdd';
      this.actId = null;
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'activityAdd';
      this.actId = row.id;
    },
    handleRecord: function handleRecord(row) {
      this.actId = row.id;
      this.publishKey++;
      this.activeTab = 'publishList';
    },
    handleReward: function handleReward(row) {
      this.actId = row.id;
      this.rewardKey++;
      this.activeTab = 'rewardList';
    },
    handleTabChange: function handleTabChange(tab) {
      if (tab.name === 'publishList') {
        this.actId = null;
        this.publishKey++;
      } else if (tab.name === 'rewardList') {
        this.actId = null;
        this.rewardKey++;
      } else if (tab.name !== 'activityAdd') {
        this.actId = null;
      }
    }
  }
};